export default {
  verifyLoginCondition: '/udb/api/user-auths/{0}/{1}/{2}/check',
  getLogin: '/udb/api/authorize/ma',
  getUser: '/uaa/api/authenticate',
  exitLogin: '/uaa/api/user/{0}/{1}/untied',
  sendCode: '/udb/api/user/sendVerifyCode',
  verifyCode: '/udb/api/user/verifyMsgCode',
  enablePersonalization: '/udb/api/personalization/enable/{0}',
  disablePersonalization: '/udb/api/personalization/disable/{0}',
  getPersonalization: '/udb/api/personalization/status/{0}',
  facialRecognition: '/udb/api/authorize/identifyVerify',
  goLogOff: '/uaa/api/user/clear/account',
  qrLogin: '/udb/api/authorize/qr-code',
  verifyRegisterEncryption: '/udb/api/user/checkPhone/new',
  loginByPassword: '/udb/api/user/login',
  loginByCode: '/udb/api/user/codeLogin',
  bindWx: '/uaa/api/user/bind',
  register: '/udb/api/user/registUser',
  changePassword: '/udb/api/user/modifyPasswd'
};
